import algoliasearch from 'algoliasearch/lite';
import https from 'https';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import { createServerRootMixin } from 'vue-instantsearch/vue3/es';

import { getConfigEntry } from '@/api/config';

const validSortingIndexes = [
  'Products',
  'ProductsByPriceDesc',
  'ProductsByPriceAsc',
  'ProductsByActivatedAtDesc',
];

/**
 * Provide access to the SSR functions in your app
 *
 * The `isServer` argument must be passed in for now, because we rely on `global.window`
 * getting mocked to parse URL parameters into refinements from the default simple router.
 * This will be easier to define as `typeof window === 'undefined'` once we wire in VueRouter.
 */
export function createSearchApp(index, router, $cloneComponent) {
  const indexName = index || 'Products';
  if (!validSortingIndexes.includes(indexName)) {
    throw new Error(`Cannot search Algolia for index ${indexName}`);
  }
  const { app, key } = getConfigEntry('algolia');
  const httpAgent = 'globalAgent' in https ? https.globalAgent : undefined;
  const searchClient = algoliasearch(app, key, { httpAgent });
  const options = {
    $cloneComponent,
    indexName,
    searchClient,
  };
  if (router) {
    options.routing = {
      router,
      stateMapping: singleIndexMapping(indexName),
    };
  }
  return createServerRootMixin(options);
}
